// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_jn-0";
export var fulfillmentPanelBody = "_jn-1";